module.exports = __webpack_public_path__ + "img/ofertas-laborales.eddb594c.webp";